export function initScrollToTab(): void {
  document.addEventListener('click', (e) => {
    const btn = (e.target as HTMLElement).closest('.js-scroll-to-tab');
    if (!btn)
      return;

    const tabId = btn.getAttribute('aria-controls');
    if (tabId === null || tabId === '')
      return;

    const tabs = document.querySelector('.js-tabs');
    if (!tabs)
      return;

    const tabBtn = tabs.querySelector<HTMLButtonElement>(`[role="tab"]#${tabId}`);
    if (!tabBtn)
      return;

    const tabButtons = tabs.querySelectorAll<HTMLButtonElement>('[role="tab"]');
    for (const tab of tabButtons) {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    }

    tabBtn.setAttribute('aria-selected', 'true');
    tabBtn.setAttribute('tabindex', '0');
    tabBtn.focus();

    const tabPanels = tabs.querySelectorAll<HTMLElement>('[role="tabpanel"]');
    for (const panel of tabPanels) {
      panel.setAttribute('hidden', 'true');
    }

    const panelId = tabBtn.getAttribute('aria-controls');
    if (panelId !== null && panelId !== '') {
      const panel = tabs.querySelector<HTMLElement>(`#${panelId}`);
      if (panel) {
        panel.removeAttribute('hidden');
      }
    }

    tabBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
